import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const getAgeValidation = async (query) => {
  try {
    let res = await Api.get("/age-validation", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getAgeValidationById = async (id) => {
  try {
    let res = await Api.get("/age-validation/" + id);

    return res?.data || {};
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const createAgeValidation = async (data) => {
  try {
    let res = await Api.post("/age-validation", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const updateAgeValidation = async (id, data) => {
  try {
    let res = await Api.patch("/age-validation/" + id, data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteAgeValidation = async (id) => {
  try {
    let res = await Api.delete("/age-validation/" + id);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
